<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (nameDirectoryPreference of nameDirectoryPreferences | async; track trackBy(nameDirectoryPreference)) {
      <lcs-option
         [value]="nameDirectoryPreference"
         id="lcs-option-id-{{ nameDirectoryPreference.nameDirectoryPreference }}"
      >
         {{ nameDirectoryPreference.nameDirectoryPreference | addSpaces }}
      </lcs-option>
      }
   </div>
</ng-template>
